<div class="content-width">
    <div class="feature-evets-wrapper">
        @for (featureEvt of featuredEventsList; track $index) {
            @if(featureEvt?.isVisible){
                <ion-card [style.cursor]="featureEvt?.url ? 'pointer' : 'initial'" (click)="navigateToEventPage(featureEvt?.url, featureEvt?.linkType)">
                    <div class="event-image"  [ngStyle]="{
                        backgroundColor: featureEvt?.bgColorCode
                      }">
                        <img alt="logo" [src]="featureEvt?.sponsor_image?.imageUrls?.medium" />
                    </div>
                    <div class="ion-card-header">
                      <div class="ion-card-title {{themeService?.isDarkMode ? 'dark': 'light'}}">{{featureEvt?.title}}</div>
                      <div class="subtitle {{themeService?.isDarkMode ? 'dark': 'light'}}">{{featureEvt?.startDate | date: 'MMM d, y' | uppercase}} - {{featureEvt?.endDate | date: 'MMM d, y' | uppercase}}</div>
                    </div>
                    @if(featureEvt?.discipline?.toLowerCase() === 'tennis'){
                        <div class="game-icon intennse">
                            <ion-icon [style.color]="featureEvt?.iconColorCode" name="tennisball"></ion-icon>
                        </div>
                    } @else {
                        <div class="game-icon pickleball">
                            <div class="colored-icon"
                                [style.backgroundColor]="featureEvt?.iconColorCode"
                                [style.maskImage]="'url(' + pickleballIcon + ')'"
                                [style.webkitMaskImage]="'url(' + pickleballIcon + ')'"
                                [style.maskSize]="'contain'"
                                [style.webkitMaskSize]="'contain'"
                                [style.height]="'24px'"
                                [style.width]="'24px'"
                                role="img">
                            </div>
                        </div>
                    }
                </ion-card>
            }
        }

        <app-empty-page *ngIf="!featuredEventsList.length && !isLoading" text="{{'No upcoming feature events available.' | translate}}" iconName="tennisball"></app-empty-page>

        <div class="ion-padding content-width" [hidden]="!isLoading" *ngFor="let x of [0, 1, 2]">
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
        </div>
    </div>
</div>